import { string } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { createResourceLocatorString } from '../../../../util/routes';
import CustomerAlgoliaPage from '../../CustomerAlgoliaPage';
import css from './PopularDeals.module.css';
import { classNames } from 'primereact/utils';

const PopularDeals = props => {
  const { dealFilterParams, intl, history, routeConfiguration } = props;
  const arabicLanguage =
    typeof window !== 'undefined' && localStorage.getItem('language') === 'Arabic';

  // Geolocation is still picked up so deal cards can show distances.
  const [currLocation, setCurrLocation] = useState({});

  useEffect(() => {
    if (!navigator.geolocation) {
      return;
    }

    navigator.geolocation.getCurrentPosition(
      position => {
        const { latitude, longitude } = position.coords;
        setCurrLocation({
          lat: parseFloat(latitude.toFixed(3)),
          lng: parseFloat(longitude.toFixed(3)),
        });
      },
      () => {
        // Keep the cards working without distance if location access is denied.
      }
    );
  }, []);

  return (
    <section
      className={classNames(
        css.popularDealsWrapper,
        arabicLanguage && css.arabicRowReverse
      )}
    >
      {/* `.inner` re-applies the centered max-width / horizontal padding so
          we keep readable line lengths while the surface bg goes full-bleed,
          matching Lovable's `<section className="bg-surface">` pattern. */}
      <div className={css.inner}>
        {/* Header — matches Lovable HappeningNow.tsx:
            [Live now pill]                       [View all deals button]
            [Deals ending soon heading]
            [Subheading] */}
        <div className={css.headingArea}>
          <div className={css.headingLeft}>
            <div className={css.livePill}>
              <span className={css.liveDot} aria-hidden="true">
                <span className={css.liveDotPing} />
                <span className={css.liveDotCore} />
              </span>
              {intl.formatMessage({ id: 'PopularDeals.liveNow' })}
            </div>
            <h2 className={css.heading}>
              {intl.formatMessage({ id: 'PopularDeals.popularDealsHeading' })}
            </h2>
            <p className={css.subheading}>
              {intl.formatMessage({ id: 'PopularDeals.subheading' })}
            </p>
          </div>
          {history && routeConfiguration && (
            <button
              type="button"
              className={css.viewAllButton}
              onClick={() =>
                history.push(
                  createResourceLocatorString(
                    'AlgoliaSearchPage',
                    routeConfiguration,
                    { listingType: 'deals' },
                    {}
                  )
                )
              }
            >
              {intl.formatMessage({ id: 'PopularDeals.viewAllDeals' })}
            </button>
          )}
        </div>

        <div className={css.popularBody}>
          <div className={css.dealsResults}>
            <CustomerAlgoliaPage
              searchContentsClass={css.dealResultsSearchContents}
              dealFilterParams={dealFilterParams}
              userLocation={currLocation}
              hitsPerPage={6}
              dealIndexName={
                process.env.REACT_APP_ALGOLIA_DEALS_RATING_INDEX ||
                process.env.REACT_APP_ALGOLIA_DEALS_INDEX
              }
            />
          </div>
        </div>
      </div>
    </section>
  );
};

PopularDeals.defaultProps = {
  className: null,
  rootClassName: null,
};

PopularDeals.propTypes = {
  className: string,
  rootClassName: string,
};

export default PopularDeals;
